// GAVION commissions: labels and refusal messages shared by every commissions screen.
export const commissionsFr = {
  sources: {
    rep_appointment: "Rendez-vous du représentant",
    inbound: "Organique (le client est venu de lui-même)",
    referral: "Référence",
    assigned: "Client attribué",
  },
  lines: {
    reception: "Réceptionniste",
    admin_assistant: "Adjointe administrative",
  },
  tiers: { essentiel: "Essentiel", avance: "Avancé", entreprise: "Entreprise" },
  billing: { monthly: "Mensuel", annual: "Annuel" },
  addon_billing: {
    monthly: "par mois",
    per_unit_in_month: "par unité dans le mois",
  },
  exception_kinds: {
    unpaid: "Impayé",
    refunded: "Remboursé",
    partial: "Partiel",
  },
  line_kinds: {
    commission: "Commission",
    bonus: "Prime",
    adjustment: "Ajustement",
    to_decide: "À décider",
  },
  statement_status: { draft: "Brouillon", paid: "Versé" },
  errors: {
    forbidden: "Réservé aux administrateurs.",
    not_found: "Introuvable.",
    invalid_deal: "Cette opportunité n'appartient pas à ce client.",
    invalid_month: "Mois invalide pour cet abonnement.",
    invalid_billing: "Choisissez une facturation.",
    invalid_package: "Choisissez un forfait actif.",
    invalid_annual_amount:
      "Entrez le montant annuel payé (facturation annuelle seulement).",
    invalid_addons: "Option invalide pour ce forfait : %{detail}",
    invalid_services:
      "Service récurrent invalide : un nom et un montant mensuel entre 0 et 100 000 $.",
    decision_pending:
      "Ce relevé a une ligne « À décider » : enregistrez le partage convenu sur l'opportunité (Étapes de la vente), puis actualisez le relevé.",
    employment_ended:
      "Cette personne a quitté l'entreprise le %{detail} : ce brouillon paie un mois après cette date (art. 4.3.2). Actualisez le relevé avant de le marquer versé.",
    stale_draft:
      "Ce brouillon n'est plus à jour (un abonnement, une étape de la vente ou un plan a changé) : actualisez-le avant de le marquer versé.",
    invalid_settlement:
      "Choisissez comment c'est réglé : retenue (consentement écrit), remboursé ou abandonné.",
    not_open:
      "Une correction maintenant due annule déjà ce montant : rien à abandonner (il sera fermé au prochain versement). S'il a été remboursé ou retenu, choisissez « Remboursé » ou « Retenue ».",
    not_to_settle:
      "Seule une correction négative d'un relevé versé se règle avec l'employé.",
    already_settled: "Ce montant est déjà marqué réglé.",
    invalid_note: "La note est trop longue.",
    subscription_exists: "Ce client a déjà un abonnement actif.",
    subscription_cancelled: "Cet abonnement est résilié.",
    deal_already_subscribed:
      "Cette opportunité a déjà un abonnement : une « Nouvelle vente » demande une nouvelle opportunité, sinon choisissez « Reprise ».",
    invalid_continuation:
      "Reprise impossible : choisissez un abonnement résilié de ce client, terminé avant le premier mois payé et pas déjà repris, sans opportunité ou avec celle d’origine.",
    invalid_exception:
      "Exception invalide : un montant pour « Partiel » seulement.",
    invalid_fee: "Entrez un montant et une note.",
    invalid_discount: "Entrez un pourcentage entre 0 et 100.",
    plan_overlap: "Cette personne a déjà un plan pour cette période.",
    plan_in_force:
      "Ce plan est déjà en vigueur : « %{detail} » ne change plus (le passé ne se réécrit pas). Créez une nouvelle version à partir de ce mois-ci, ou entrez une date de fin.",
    invalid_plan: "Plan invalide : %{detail}.",
    version_date:
      "La nouvelle version commence ce mois-ci ou plus tard, après le début du plan actuel.",
    invalid_cutoff: "Choisissez une date de fin passée ou aujourd'hui.",
    invalid_date:
      "Date de versement invalide : le jour de la date de fin du relevé ou après, et pas dans le futur.",
    invalid_paid_on: "Entrez la date du versement.",
    draft_exists:
      "Un relevé brouillon existe déjà pour cette personne : actualisez-le ou supprimez-le.",
    statement_locked: "Ce relevé est versé : il ne change plus.",
    sale_steps_admin_only:
      "Seul un administrateur peut changer les étapes de la vente.",
    invalid_role_holder:
      "Ce rôle doit être confié à un utilisateur actif (%{detail}).",
    unknown_report: "Rapport inconnu.",
    managed_by_stripe:
      "Géré par Stripe : changez-le dans Stripe, la synchronisation l'applique ici.",
    invalid_price_map:
      "Associez le prix à un forfait ou à une option (un seul).",
    unknown: "Erreur inattendue (code : %{code}).",
  },
  errors_detail: {
    invalid_month: {
      overlaps_cancelled:
        "Ce mois tombe dans un abonnement résilié de ce client : choisissez un premier mois après son dernier mois facturé.",
    },
    invalid_exception: {
      above_mrr: "Le montant perçu dépasse le MRR facturé ce mois-là.",
    },
    invalid_continuation: {
      deal: "Une reprise garde l'opportunité d'origine : laissez l'opportunité vide.",
    },
    plan_in_force: {
      delete:
        "Ce plan est déjà en vigueur : il ne se supprime pas. Entrez une date de fin ou une fin d'emploi.",
    },
  },
};
